import React from 'react'
import LeaveCreate from '../components/LeaveCreate'
import LeaveOfYear from '../components/LeaveOfYear/LeaveOfYearCrate'

const LeaveRequest = () => {
   
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <LeaveCreate />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <LeaveOfYear EmpNO={JSON.parse(localStorage.getItem("profile")).EMP_NO} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeaveRequest;
